export default __webpack_public_path__ + "static/okr-outcome-a49d34e6cef21e91c3645bd8d267dc8d.mp4";